<template lang='pug'>
.mr-site-search(v-bind:class="{open: control.open}" v-bind:aria-hidden="!control.open")
  .close-search(v-on:click="control.open = !control.open;")
  .fixed-width-tweak-upper
    .search-wrap
      form.search-form(v-on:submit.prevent="performSearch()")
        label.search-text.xs-hide.sm-hide.md-hide.lg-f-large.max-at-tweak(v-on:click="performSearch()" for="site-search")
          span.icon-magnify
          span.xs-f-xmedium.md-f-large.lg-f-xmedium.max-at-tweak Search anytime by typing and hit enter
        .input-wrap
          input#site-search.search-input(ref="searchInput" v-model="searchTerm" placeholder="search" required v-bind:tabindex="control.open ? 0 : -1")

        button.search-button.bg-purple.lg-hide(type="submit")
          span.icon-magnify.color-white
            span.ada-tooltip search

      button.icon-x.btn-reset.clickable.xs-f-xlarge.md-f-xxlarge.lg-f-xlarge.max-at-tweak(v-on:click="control.open = !control.open;" v-bind:tabindex="control.open ? 0 : -1")
        span.ada-tooltip close

</template>

<script>
  export default {
    props: ['control'],
    data: function() {
      return {
        searchTerm: '',
        searching: false
      }
    },
    watch: {
      'control.open': function(newValue) {
        if (newValue) {
          this.$refs.searchInput.focus();
        }
      }
    },
    methods: {
      performSearch() {
        this.control.open = false;
        window.location = '/search/' + encodeURIComponent(this.searchTerm);
      }
    }
  };
</script>

<styl lang='stylus' scoped>

</styl>